import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetArgs } from '../../base/baseGet.args'

@ArgsType()
export class ArcClaimGetArgs extends BaseGetArgs<ArcClaimGetArgs> {
  @Field(t => Int, { nullable: true })
  userId?: number

  @Field(t => Int, { nullable: true })
  arcId?: number

  @Field(t => Int, { nullable: true })
  bookId?: number

  @Field(t => Int, { nullable: true })
  status?: number

  @Field(t => [Int], { nullable: true })
  statuses?: number[]

  @Field(t => Int, { nullable: true })
  claimId?: number

  @Field({ nullable: true })
  userSearchNeedle?: string

  @Field(t => Int, { nullable: true })
  type?: number

  @Field(t => Int, { nullable: true })
  reviewSiteStatus?: number

  @Field({ nullable: true })
  forAuthenticatedUser?: boolean

  @Field({ nullable: true })
  mustHaveReviews?: boolean

  @Field(t => Int, { nullable: true })
  groupByStatus?: number

  @Field(t => [Int], { nullable: true })
  audienceTypes?: number[]

  @Field(t => Int, { nullable: true })
  categoryId?: number

  @Field({ nullable: true })
  isDue?: boolean

  @Field({ nullable: true })
  countOnly?: string

  @Field(t => Int, { nullable: true })
  arcTeamId?: number

  @Field(t => Int, { nullable: true })
  authorPenNameId?: number
}
